import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  DateTime: { input: string; output: string };
  EmailAddress: { input: unknown; output: unknown };
  JSON: { input: unknown; output: unknown };
  NonEmptyString: { input: string; output: string };
  NonNegativeFloat: { input: unknown; output: unknown };
  NonNegativeInt: { input: number; output: number };
  PhoneNumber: { input: string; output: string };
  URL: { input: unknown; output: unknown };
  USCurrency: { input: number; output: string };
  ZipCode: { input: unknown; output: unknown };
};

export enum AdditionalRequirement {
  CONSUMER_REPORT = 'CONSUMER_REPORT',
  NONE = 'NONE',
}

export enum AnswerType {
  boolean = 'boolean',
  string = 'string',
}

export type Answers = {
  __typename?: 'Answers';
  /** @deprecated aboutMe field has been removed */
  aboutMe?: Maybe<Scalars['String']['output']>;
  backgroundReportComment?: Maybe<Scalars['String']['output']>;
  coapplicants?: Maybe<Array<Maybe<SentCoapplicantInvitation>>>;
  creditReportComment?: Maybe<Scalars['String']['output']>;
  currentIncome?: Maybe<CurrentIncome>;
  currentIncomes?: Maybe<Array<Maybe<CurrentIncome>>>;
  currentResidence?: Maybe<CurrentResidence>;
  customAnswers?: Maybe<Array<Maybe<CustomAnswer>>>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isMoveInDateFlexible?: Maybe<Scalars['Boolean']['output']>;
  isSmoker?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  moveInDate?: Maybe<Scalars['Date']['output']>;
  occupants?: Maybe<Scalars['Int']['output']>;
  pastJobs?: Maybe<Array<Maybe<PastJob>>>;
  pastResidences?: Maybe<Array<Maybe<PastResidence>>>;
  pets?: Maybe<Pets>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  reasonForMoving?: Maybe<Scalars['String']['output']>;
};

export type AnswerscurrentIncomeArgs = {
  id: Scalars['ID']['input'];
};

export type AnswersInput = {
  /** @deprecated aboutMe field has been removed */
  aboutMe?: InputMaybe<Scalars['NonEmptyString']['input']>;
  backgroundReportComment?: InputMaybe<Scalars['NonEmptyString']['input']>;
  creditReportComment?: InputMaybe<Scalars['NonEmptyString']['input']>;
  currentIncomes?: InputMaybe<Array<InputMaybe<CurrentIncomeInputWithId>>>;
  currentResidence?: InputMaybe<ResidenceInput>;
  customAnswers?: InputMaybe<Array<InputMaybe<CustomAnswerInput>>>;
  firstName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  isMoveInDateFlexible?: InputMaybe<Scalars['Boolean']['input']>;
  isSmoker?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  moveInDate?: InputMaybe<Scalars['Date']['input']>;
  occupants?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pastJobs?: InputMaybe<Array<InputMaybe<PastJobInputWithId>>>;
  pastResidences?: InputMaybe<Array<InputMaybe<ResidenceInputWithId>>>;
  pets?: InputMaybe<PetsInput>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  reasonForMoving?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type AppfolioRentalApplication = {
  __typename?: 'AppfolioRentalApplication';
  address?: Maybe<RentalApplicationAddress>;
  applicationUrl?: Maybe<Scalars['String']['output']>;
  approvedDateTime?: Maybe<Scalars['DateTime']['output']>;
  declinedDateTime?: Maybe<Scalars['DateTime']['output']>;
  displayablePhotoUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  listingAlias?: Maybe<Scalars['String']['output']>;
  startedDateTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ApplicationStatus>;
  submittedDateTime?: Maybe<Scalars['DateTime']['output']>;
  withdrawnDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type Applicant = {
  __typename?: 'Applicant';
  answers?: Maybe<Answers>;
  /** @deprecated All fields of this object will be null except for 'invitedDateTime', see RA-7590 */
  coapplicantInvitation?: Maybe<SentCoapplicantInvitation>;
  id?: Maybe<Scalars['ID']['output']>;
  isPrimaryApplicant?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This is always null, see RA-7590 */
  landlordInvitation?: Maybe<SentLandlordInvitation>;
  status?: Maybe<ApplicantStatus>;
  submittedDateTime?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  userStatuses?: Maybe<Array<Maybe<UserStatus>>>;
  zgAuthZone?: Maybe<ZgAuthZone>;
};

export type ApplicantContactInfo = {
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export enum ApplicantStatus {
  completed = 'completed',
  pending = 'pending',
  withdrawn = 'withdrawn',
}

export type ApplicationShareInformation = {
  __typename?: 'ApplicationShareInformation';
  landlordEmail?: Maybe<Scalars['EmailAddress']['output']>;
  propertyAddress?: Maybe<RentalApplicationAddress>;
  propertyId?: Maybe<Scalars['ID']['output']>;
  shareDateTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ApplicationShareStatus>;
};

export enum ApplicationShareStatus {
  accepted = 'accepted',
  declined = 'declined',
  invited = 'invited',
  resubmitRequired = 'resubmitRequired',
  shared = 'shared',
  withdrawn = 'withdrawn',
}

export enum ApplicationStatus {
  /** @deprecated Use RentalApplication.applicationStatus */
  active = 'active',
  approved = 'approved',
  conditionally_approved = 'conditionally_approved',
  declined = 'declined',
  invited = 'invited',
  invited_and_started = 'invited_and_started',
  /** @deprecated Use RentalApplication.applicationStatus */
  invited_to_move_in = 'invited_to_move_in',
  partially_submitted = 'partially_submitted',
  started = 'started',
  submitted = 'submitted',
  withdrawn = 'withdrawn',
}

export type ApplicationStatusHistory = {
  __typename?: 'ApplicationStatusHistory';
  date?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  viewed?: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanAnswer = CustomAnswer & {
  __typename?: 'BooleanAnswer';
  id?: Maybe<Scalars['ID']['output']>;
  question?: Maybe<Question>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type BulkCurrentIncomeInput = {
  currentIncome: CurrentIncomeInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkPastJobInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pastJob: PastJobInput;
};

export type BulkResidenceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  residence: ResidenceInput;
};

export type Category = {
  __typename?: 'Category';
  id?: Maybe<Scalars['ID']['output']>;
  pages?: Maybe<Array<Maybe<Page>>>;
};

export type Choice = {
  __typename?: 'Choice';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum CoreQuestionId {
  aboutMe = 'aboutMe',
  backgroundReportComment = 'backgroundReportComment',
  creditReportComment = 'creditReportComment',
  currentResidence = 'currentResidence',
  firstName = 'firstName',
  isMoveInDateFlexible = 'isMoveInDateFlexible',
  isSmoker = 'isSmoker',
  lastName = 'lastName',
  middleName = 'middleName',
  moveInDate = 'moveInDate',
  occupants = 'occupants',
  pets = 'pets',
  phone = 'phone',
  reasonForMoving = 'reasonForMoving',
}

export type CurrentIncome = {
  amount?: Maybe<Scalars['USCurrency']['output']>;
  areDocumentsExpired?: Maybe<Scalars['Boolean']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  id?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer verifying income */
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<IncomeType>;
  /** @deprecated No longer verifying income */
  verification?: Maybe<IncomeVerification>;
};

export type CurrentIncomeInput = {
  amount?: InputMaybe<Scalars['USCurrency']['input']>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  employer?: InputMaybe<EmployerInput>;
  note?: InputMaybe<Scalars['NonEmptyString']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type: IncomeType;
};

export type CurrentIncomeInputWithId = {
  amount?: InputMaybe<Scalars['USCurrency']['input']>;
  documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
  employer?: InputMaybe<EmployerInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  incomeSourceId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['NonEmptyString']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  type: IncomeType;
};

export type CurrentResidence = {
  address?: Maybe<RentalApplicationAddress>;
  id?: Maybe<Scalars['ID']['output']>;
  monthlyPayment?: Maybe<Scalars['USCurrency']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<ResidenceType>;
  zpid?: Maybe<Scalars['Int']['output']>;
};

export type CustomAnswer = {
  id?: Maybe<Scalars['ID']['output']>;
  question?: Maybe<Question>;
};

export type CustomAnswerInput = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type DeclineReason = {
  __typename?: 'DeclineReason';
  additionalRequirement?: Maybe<AdditionalRequirement>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<DeclineReasonType>;
};

export enum DeclineReasonType {
  BACKGROUND_CHECK = 'BACKGROUND_CHECK',
  BACKGROUND_CRIMINAL_REPORT = 'BACKGROUND_CRIMINAL_REPORT',
  CREDIT_REPORT = 'CREDIT_REPORT',
  INSUFFICIENT_RENT_INCOME_RATIO = 'INSUFFICIENT_RENT_INCOME_RATIO',
  INVALID_REF_CHECK = 'INVALID_REF_CHECK',
  INV_APPLICATION_REQ = 'INV_APPLICATION_REQ',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  PETS = 'PETS',
  SMOKING = 'SMOKING',
}

export type Document = {
  __typename?: 'Document';
  /** Determines if this document has a redacted version that can be toggled by setDocumentRedactionStatus. */
  canBeRedacted?: Maybe<Scalars['Boolean']['output']>;
  editorUrl?: Maybe<Scalars['URL']['output']>;
  expirationDateTime?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isRedacted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * - false if the redaction check is still loading and the canBeRedacted field should continue to be polled
   * - true if the redaction check is done and canBeRedacted now has its final value, so polling can stop
   */
  isRedactionCheckComplete?: Maybe<Scalars['Boolean']['output']>;
  previewUrl?: Maybe<Scalars['URL']['output']>;
};

export type DocumentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isRedacted?: InputMaybe<Scalars['Boolean']['input']>;
  messageToken?: InputMaybe<Scalars['ID']['input']>;
};

export type EditCoapplicantInput = {
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
};

export type Employer = ReferenceContactInfo & {
  __typename?: 'Employer';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type EmployerInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  organization?: InputMaybe<Scalars['NonEmptyString']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type EmploymentIncome = CurrentIncome & {
  __typename?: 'EmploymentIncome';
  amount?: Maybe<Scalars['USCurrency']['output']>;
  areDocumentsExpired?: Maybe<Scalars['Boolean']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  employer?: Maybe<Employer>;
  id?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer verifying income */
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<IncomeType>;
  /** @deprecated No longer verifying income */
  verification?: Maybe<IncomeVerification>;
};

export enum IncomeType {
  employment = 'employment',
  other = 'other',
  selfEmployed = 'selfEmployed',
  voucher = 'voucher',
}

export type IncomeVerification = {
  __typename?: 'IncomeVerification';
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<IncomeVerificationVendor>;
  verifiedDate?: Maybe<Scalars['Date']['output']>;
};

export enum IncomeVerificationVendor {
  finicity = 'finicity',
}

export type InviteCoapplicantInput = {
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
};

export type InvitedByContactInfo = ApplicantContactInfo & {
  __typename?: 'InvitedByContactInfo';
  applicationId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type LandlordRentalApplication = {
  __typename?: 'LandlordRentalApplication';
  applicant?: Maybe<Applicant>;
  applicants?: Maybe<Array<Maybe<Applicant>>>;
  conditionallyApprovedDateTime?: Maybe<Scalars['DateTime']['output']>;
  declinedDateTime?: Maybe<Scalars['DateTime']['output']>;
  declinedReasons?: Maybe<Array<Maybe<DeclineReason>>>;
  id?: Maybe<Scalars['ID']['output']>;
  invitations?: Maybe<Array<Maybe<SentCoapplicantInvitation>>>;
  invitedToMoveInDateTime?: Maybe<Scalars['DateTime']['output']>;
  isViewed?: Maybe<Scalars['Boolean']['output']>;
  mergedDateTime?: Maybe<Scalars['DateTime']['output']>;
  overallStatus?: Maybe<ApplicationStatus>;
  withdrawnDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type LandlordRentalApplicationapplicantArgs = {
  userId: Scalars['ID']['input'];
  zgAuthZone: ZgAuthZone;
};

export type LinkContent = {
  __typename?: 'LinkContent';
  landlordUrl: Scalars['String']['output'];
  renterUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ListingOwner = {
  __typename?: 'ListingOwner';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ManagerContactInfo = ReferenceContactInfo & {
  __typename?: 'ManagerContactInfo';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type ManagerContactInfoInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _noop?: Maybe<Scalars['String']['output']>;
  acceptApplicationInvitation?: Maybe<RentalApplication>;
  addCurrentIncome?: Maybe<CurrentIncome>;
  /**
   * Adds a document to an income source, it is preferred over updating the whole document
   * array using the updateCurrentIncome to prevent concurrency issues
   */
  addDocumentToIncomeSource: Array<Document>;
  addPastJob?: Maybe<PastJob>;
  addPastResidence?: Maybe<PastResidence>;
  deleteAnswers?: Maybe<Answers>;
  deleteCurrentIncome?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Deletes a document from an income source, it is preferred over updating the whole document
   * array using the updateCurrentIncome to prevent concurrency issues
   */
  deleteDocumentsFromIncomeSource?: Maybe<Scalars['Boolean']['output']>;
  deletePastJob?: Maybe<Scalars['Boolean']['output']>;
  deletePastResidence?: Maybe<Scalars['Boolean']['output']>;
  editInvitation?: Maybe<SentCoapplicantInvitation>;
  inviteCoapplicant?: Maybe<SentCoapplicantInvitation>;
  markAcceptedTerms?: Maybe<Array<Maybe<Term>>>;
  markApplicationsAsViewed?: Maybe<Array<Maybe<LandlordRentalApplication>>>;
  removeInvitation?: Maybe<Scalars['Boolean']['output']>;
  replaceCurrentIncomes?: Maybe<Array<Maybe<CurrentIncome>>>;
  replacePastJobs?: Maybe<Array<Maybe<PastJob>>>;
  replacePastResidences?: Maybe<Array<Maybe<PastResidence>>>;
  saveAnswers?: Maybe<Answers>;
  /**
   * Call this with isRedacted:true only if the document canBeRedacted is true to
   * return the redacted version of previewUrl and editorUrl
   */
  setDocumentRedactionStatus?: Maybe<Scalars['Boolean']['output']>;
  shareApplication?: Maybe<RentalApplication>;
  startApplication?: Maybe<RentalApplication>;
  submitApplication?: Maybe<RentalApplication>;
  updateApplicantLastViewedSnapshotStatusDate?: Maybe<RentalApplication>;
  updateCurrentIncome?: Maybe<CurrentIncome>;
  withdrawApplication?: Maybe<Scalars['Boolean']['output']>;
  withdrawSharedApplication?: Maybe<Scalars['Boolean']['output']>;
};

export type MutationacceptApplicationInvitationArgs = {
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  invitationId: Scalars['ID']['input'];
  listingAlias: Scalars['ID']['input'];
  referrerBrand?: InputMaybe<Scalars['String']['input']>;
  requestingClient?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmGuid?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationaddCurrentIncomeArgs = {
  currentIncome: CurrentIncomeInput;
};

export type MutationaddDocumentToIncomeSourceArgs = {
  documents: Array<DocumentInput>;
  incomeSourceId: Scalars['ID']['input'];
};

export type MutationaddPastJobArgs = {
  applicationId: Scalars['ID']['input'];
  pastJob: PastJobInput;
};

export type MutationaddPastResidenceArgs = {
  applicationId: Scalars['ID']['input'];
  residence: ResidenceInput;
};

export type MutationdeleteAnswersArgs = {
  applicationId: Scalars['ID']['input'];
  coreQuestionIds?: InputMaybe<Array<InputMaybe<CoreQuestionId>>>;
  customQuestionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type MutationdeleteCurrentIncomeArgs = {
  currentIncomeId: Scalars['ID']['input'];
};

export type MutationdeleteDocumentsFromIncomeSourceArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  incomeSourceId: Scalars['ID']['input'];
};

export type MutationdeletePastJobArgs = {
  applicationId: Scalars['ID']['input'];
  pastJobId: Scalars['ID']['input'];
};

export type MutationdeletePastResidenceArgs = {
  applicationId: Scalars['ID']['input'];
  pastResidenceId: Scalars['ID']['input'];
};

export type MutationeditInvitationArgs = {
  applicant: EditCoapplicantInput;
  applicationId: Scalars['ID']['input'];
  invitationId: Scalars['ID']['input'];
};

export type MutationinviteCoapplicantArgs = {
  applicant: InviteCoapplicantInput;
  applicationId: Scalars['ID']['input'];
};

export type MutationmarkAcceptedTermsArgs = {
  terms: Array<InputMaybe<TermInput>>;
};

export type MutationmarkApplicationsAsViewedArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  listingAlias: Scalars['ID']['input'];
};

export type MutationremoveInvitationArgs = {
  applicationId: Scalars['ID']['input'];
  invitationId: Scalars['ID']['input'];
};

export type MutationreplaceCurrentIncomesArgs = {
  currentIncomes: Array<InputMaybe<BulkCurrentIncomeInput>>;
};

export type MutationreplacePastJobsArgs = {
  applicationId: Scalars['ID']['input'];
  pastJobs: Array<InputMaybe<BulkPastJobInput>>;
};

export type MutationreplacePastResidencesArgs = {
  applicationId: Scalars['ID']['input'];
  residences: Array<InputMaybe<BulkResidenceInput>>;
};

export type MutationsaveAnswersArgs = {
  answers: AnswersInput;
  applicationId: Scalars['ID']['input'];
};

export type MutationsetDocumentRedactionStatusArgs = {
  documentId: Scalars['ID']['input'];
  isRedacted: Scalars['Boolean']['input'];
};

export type MutationshareApplicationArgs = {
  landlordEmail: Scalars['EmailAddress']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  propertyAddress: ShareRentalApplicationPropertyAddressInput;
};

export type MutationstartApplicationArgs = {
  listingAlias: Scalars['ID']['input'];
  referrerBrand?: InputMaybe<Scalars['String']['input']>;
  requestingClient?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmGuid?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type MutationsubmitApplicationArgs = {
  answers?: InputMaybe<AnswersInput>;
  applicationId: Scalars['ID']['input'];
};

export type MutationupdateApplicantLastViewedSnapshotStatusDateArgs = {
  applicationId: Scalars['ID']['input'];
};

export type MutationupdateCurrentIncomeArgs = {
  currentIncome: CurrentIncomeInput;
  currentIncomeId: Scalars['ID']['input'];
};

export type MutationwithdrawApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};

export type MutationwithdrawSharedApplicationArgs = {
  shareId: Scalars['ID']['input'];
};

export type OtherCurrentResidence = CurrentResidence &
  OtherResidence &
  Residence & {
    __typename?: 'OtherCurrentResidence';
    address?: Maybe<RentalApplicationAddress>;
    description?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    monthlyPayment?: Maybe<Scalars['USCurrency']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    type?: Maybe<ResidenceType>;
    zpid?: Maybe<Scalars['Int']['output']>;
  };

export type OtherIncome = CurrentIncome & {
  __typename?: 'OtherIncome';
  amount?: Maybe<Scalars['USCurrency']['output']>;
  areDocumentsExpired?: Maybe<Scalars['Boolean']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  id?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer verifying income */
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<IncomeType>;
  /** @deprecated No longer verifying income */
  verification?: Maybe<IncomeVerification>;
};

export type OtherPastResidence = OtherResidence &
  PastResidence &
  Residence & {
    __typename?: 'OtherPastResidence';
    address?: Maybe<RentalApplicationAddress>;
    description?: Maybe<Scalars['String']['output']>;
    endDate?: Maybe<Scalars['Date']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    type?: Maybe<ResidenceType>;
  };

export type OtherResidence = {
  description?: Maybe<Scalars['String']['output']>;
};

export type OwnedCurrentResidence = CurrentResidence &
  Residence & {
    __typename?: 'OwnedCurrentResidence';
    address?: Maybe<RentalApplicationAddress>;
    id?: Maybe<Scalars['ID']['output']>;
    monthlyPayment?: Maybe<Scalars['USCurrency']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    type?: Maybe<ResidenceType>;
    zpid?: Maybe<Scalars['Int']['output']>;
  };

export type OwnedPastResidence = PastResidence &
  Residence & {
    __typename?: 'OwnedPastResidence';
    address?: Maybe<RentalApplicationAddress>;
    endDate?: Maybe<Scalars['Date']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    type?: Maybe<ResidenceType>;
  };

export type Page = {
  __typename?: 'Page';
  id?: Maybe<Scalars['ID']['output']>;
  questions?: Maybe<Array<Maybe<Question>>>;
};

export type PastJob = {
  __typename?: 'PastJob';
  employer?: Maybe<Employer>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PastJobInput = {
  employer?: InputMaybe<EmployerInput>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PastJobInputWithId = {
  employer?: InputMaybe<EmployerInput>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  incomeSourceId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PastResidence = {
  address?: Maybe<RentalApplicationAddress>;
  endDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<ResidenceType>;
};

export type Pets = {
  __typename?: 'Pets';
  cats?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  largeDogs?: Maybe<Scalars['Int']['output']>;
  mediumDogs?: Maybe<Scalars['Int']['output']>;
  other?: Maybe<Scalars['Int']['output']>;
  smallDogs?: Maybe<Scalars['Int']['output']>;
};

export type PetsInput = {
  cats: Scalars['NonNegativeInt']['input'];
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  largeDogs: Scalars['NonNegativeInt']['input'];
  mediumDogs: Scalars['NonNegativeInt']['input'];
  other: Scalars['NonNegativeInt']['input'];
  smallDogs: Scalars['NonNegativeInt']['input'];
};

export enum PropertyType {
  condo = 'condo',
  divided = 'divided',
  garden = 'garden',
  house = 'house',
  land = 'land',
  large = 'large',
  townhouse = 'townhouse',
  unknown = 'unknown',
}

export type Query = {
  __typename?: 'Query';
  _noop?: Maybe<Scalars['String']['output']>;
  appfolioRentalApplications?: Maybe<Array<Maybe<AppfolioRentalApplication>>>;
  idVerification?: Maybe<UserStatus>;
  isIpAddressInTheUs?: Maybe<Scalars['Boolean']['output']>;
  rentalApplication?: Maybe<RentalApplication>;
  rentalApplicationPrice?: Maybe<Scalars['USCurrency']['output']>;
  rentalApplications?: Maybe<Array<Maybe<RentalApplication>>>;
  rentalApplicationsBrownoutWarning?: Maybe<Scalars['String']['output']>;
  rentalApplicationsDocumentUploadToken?: Maybe<Scalars['String']['output']>;
  rentalListing?: Maybe<RentalListing>;
  termSet?: Maybe<TermSet>;
  userStatuses?: Maybe<Array<Maybe<UserStatus>>>;
};

export type QueryidVerificationArgs = {
  zgAuthZone?: InputMaybe<ZgAuthZone>;
};

export type QueryrentalApplicationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryrentalApplicationPriceArgs = {
  listingAlias?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryrentalApplicationsArgs = {
  includeSharedApplications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryrentalListingArgs = {
  id: Scalars['ID']['input'];
};

export type QuerytermSetArgs = {
  id: TermSetId;
};

export type Question = {
  answerType?: Maybe<AnswerType>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  shortLabel?: Maybe<Scalars['String']['output']>;
};

export type QuestionMeta = {
  __typename?: 'QuestionMeta';
  categories?: Maybe<Array<Maybe<Category>>>;
  isVoiEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type RadioQuestion = Question & {
  __typename?: 'RadioQuestion';
  answerType?: Maybe<AnswerType>;
  choices?: Maybe<Array<Maybe<Choice>>>;
  help?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  shortLabel?: Maybe<Scalars['String']['output']>;
};

export type ReceivedCoapplicantInvitation = {
  __typename?: 'ReceivedCoapplicantInvitation';
  id?: Maybe<Scalars['ID']['output']>;
  invitedBy?: Maybe<InvitedByContactInfo>;
  rentalApplicationInviteId?: Maybe<Scalars['ID']['output']>;
};

export type ReferenceContactInfo = {
  email?: Maybe<Scalars['EmailAddress']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type RentalApplication = {
  __typename?: 'RentalApplication';
  answers?: Maybe<Answers>;
  applicationShareInformation?: Maybe<ApplicationShareInformation>;
  applicationStatus?: Maybe<ApplicationStatus>;
  conditionallyApprovedDateTime?: Maybe<Scalars['DateTime']['output']>;
  declinedDateTime?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invitedDateTime?: Maybe<Scalars['DateTime']['output']>;
  invitedToMoveInDateTime?: Maybe<Scalars['DateTime']['output']>;
  ireneViewedDateTime?: Maybe<Scalars['DateTime']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isPrimaryApplicant?: Maybe<Scalars['Boolean']['output']>;
  listingOwner?: Maybe<ListingOwner>;
  /** @deprecated Use RentalApplication.applicationStatus */
  overallStatus?: Maybe<ApplicationStatus>;
  price?: Maybe<Scalars['USCurrency']['output']>;
  rentalListing?: Maybe<RentalListing>;
  startedByText?: Maybe<Scalars['String']['output']>;
  startedDateTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ApplicantStatus>;
  statusHistory?: Maybe<Array<Maybe<ApplicationStatusHistory>>>;
  statusLastViewedByRachel?: Maybe<Scalars['DateTime']['output']>;
  submittedDateTime?: Maybe<Scalars['DateTime']['output']>;
  withdrawnDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type RentalApplicationAddress = {
  __typename?: 'RentalApplicationAddress';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['ZipCode']['output']>;
};

export type RentalApplicationAddressInput = {
  city?: InputMaybe<Scalars['NonEmptyString']['input']>;
  state?: InputMaybe<Scalars['NonEmptyString']['input']>;
  street?: InputMaybe<Scalars['NonEmptyString']['input']>;
  zip?: InputMaybe<Scalars['ZipCode']['input']>;
};

export type RentalCurrentResidence = CurrentResidence &
  RentalResidence &
  Residence & {
    __typename?: 'RentalCurrentResidence';
    address?: Maybe<RentalApplicationAddress>;
    id?: Maybe<Scalars['ID']['output']>;
    manager?: Maybe<ManagerContactInfo>;
    monthlyPayment?: Maybe<Scalars['USCurrency']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    type?: Maybe<ResidenceType>;
    zpid?: Maybe<Scalars['Int']['output']>;
  };

export type RentalListing = {
  __typename?: 'RentalListing';
  address?: Maybe<RentalApplicationAddress>;
  bathrooms?: Maybe<Scalars['NonNegativeFloat']['output']>;
  bedrooms?: Maybe<Scalars['NonNegativeInt']['output']>;
  contact?: Maybe<RentalListingContactDetails>;
  id?: Maybe<Scalars['ID']['output']>;
  invitationsToApply?: Maybe<Array<Maybe<SentLandlordInvitation>>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isApplicationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  landlordRentalApplication?: Maybe<LandlordRentalApplication>;
  landlordRentalApplications?: Maybe<Array<Maybe<LandlordRentalApplication>>>;
  listingAlias?: Maybe<Scalars['String']['output']>;
  monthlyPayment?: Maybe<Scalars['USCurrency']['output']>;
  photos?: Maybe<Array<Maybe<RentalListingPhoto>>>;
  primaryPhoto?: Maybe<RentalListingPhoto>;
  propertyType?: Maybe<PropertyType>;
  propertyUrl?: Maybe<Scalars['URL']['output']>;
  questionMeta?: Maybe<QuestionMeta>;
  receivedInvitations?: Maybe<Array<Maybe<ReceivedCoapplicantInvitation>>>;
  rentalApplications?: Maybe<Array<Maybe<RentalApplication>>>;
  squareFeet?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type RentalListinglandlordRentalApplicationArgs = {
  id: Scalars['ID']['input'];
};

export type RentalListinglandlordRentalApplicationsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RentalListingContactDetails = {
  __typename?: 'RentalListingContactDetails';
  name?: Maybe<Scalars['String']['output']>;
};

export type RentalListingPhoto = {
  __typename?: 'RentalListingPhoto';
  imageUrl?: Maybe<Scalars['URL']['output']>;
  thumbUrl?: Maybe<Scalars['URL']['output']>;
};

export type RentalPastResidence = PastResidence &
  RentalResidence &
  Residence & {
    __typename?: 'RentalPastResidence';
    address?: Maybe<RentalApplicationAddress>;
    endDate?: Maybe<Scalars['Date']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    manager?: Maybe<ManagerContactInfo>;
    startDate?: Maybe<Scalars['Date']['output']>;
    type?: Maybe<ResidenceType>;
  };

export type RentalResidence = {
  manager?: Maybe<ManagerContactInfo>;
};

export type Residence = {
  address?: Maybe<RentalApplicationAddress>;
  id?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<ResidenceType>;
};

export type ResidenceInput = {
  address?: InputMaybe<RentalApplicationAddressInput>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  manager?: InputMaybe<ManagerContactInfoInput>;
  monthlyPayment?: InputMaybe<Scalars['USCurrency']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  type: ResidenceType;
  zpid?: InputMaybe<Scalars['Int']['input']>;
};

export type ResidenceInputWithId = {
  address?: InputMaybe<RentalApplicationAddressInput>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  manager?: InputMaybe<ManagerContactInfoInput>;
  monthlyPayment?: InputMaybe<Scalars['USCurrency']['input']>;
  residenceId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  type: ResidenceType;
};

export enum ResidenceType {
  other = 'other',
  own = 'own',
  rent = 'rent',
}

export type SentCoapplicantInvitation = ApplicantContactInfo & {
  __typename?: 'SentCoapplicantInvitation';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** The 'inviteId' that can be used to edit or remove an invitation */
  id?: Maybe<Scalars['ID']['output']>;
  invitedDateTime?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type SentLandlordInvitation = {
  __typename?: 'SentLandlordInvitation';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  invitedDateTime?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ShareRentalApplicationPropertyAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  propertyId: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['ZipCode']['input']>;
};

export type Term = {
  __typename?: 'Term';
  acceptanceDateTime?: Maybe<Scalars['DateTime']['output']>;
  acceptedVersion?: Maybe<Scalars['Int']['output']>;
  content?: Maybe<TermContent>;
  currentVersion?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<TermId>;
  /** @deprecated Use Term.acceptedVersion */
  version?: Maybe<Scalars['Int']['output']>;
};

export type TermContent = LinkContent | TextContent;

export enum TermId {
  CIC_CONFIRMATION_RENTER = 'CIC_CONFIRMATION_RENTER',
  CIC_TAC = 'CIC_TAC',
  EXPERIAN_CIC_WRITTEN_CONSENT_RENTER = 'EXPERIAN_CIC_WRITTEN_CONSENT_RENTER',
  EXPERIAN_PRIVACY_POLICY = 'EXPERIAN_PRIVACY_POLICY',
  EXPERIAN_TAC = 'EXPERIAN_TAC',
  EXPERIAN_WRITTEN_CONSENT = 'EXPERIAN_WRITTEN_CONSENT',
  EXPERIAN_WRITTEN_CONSENT_LANDLORD = 'EXPERIAN_WRITTEN_CONSENT_LANDLORD',
  EXPERIAN_WRITTEN_CONSENT_RENTER = 'EXPERIAN_WRITTEN_CONSENT_RENTER',
  TERMS_ZILLOW_RENTAL_USER = 'TERMS_ZILLOW_RENTAL_USER',
  ZILLOW_RENTAL_PLAID_CHECK_TERMS = 'ZILLOW_RENTAL_PLAID_CHECK_TERMS',
}

export type TermInput = {
  termId: TermId;
  version: Scalars['Int']['input'];
};

export type TermSet = {
  __typename?: 'TermSet';
  id?: Maybe<TermSetId>;
  status?: Maybe<TermSetStatus>;
  terms?: Maybe<Array<Maybe<Term>>>;
};

export enum TermSetId {
  landlordScreening = 'landlordScreening',
  renterScreening = 'renterScreening',
}

export enum TermSetStatus {
  current = 'current',
  never = 'never',
  previous = 'previous',
}

export type TextContent = {
  __typename?: 'TextContent';
  text: Scalars['String']['output'];
};

export type UserStatus = {
  __typename?: 'UserStatus';
  /** @deprecated Use expirationDateTime */
  expiration?: Maybe<Scalars['DateTime']['output']>;
  expirationDateTime?: Maybe<Scalars['DateTime']['output']>;
  requestedDateTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<UserStatusType>;
};

export enum UserStatusType {
  backgroundReport = 'backgroundReport',
  creditReport = 'creditReport',
  idverification = 'idverification',
  rentalApplicationPayment = 'rentalApplicationPayment',
  screeningReportShare = 'screeningReportShare',
}

export enum ZgAuthZone {
  hotpads = 'hotpads',
  trulia = 'trulia',
  zillow = 'zillow',
  zrm = 'zrm',
}

export type GetApplicationsForUserQueryVariables = Exact<{
  includeSharedApplications?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetApplicationsForUserQuery = {
  __typename?: 'Query';
  rentalApplications?: Array<{
    __typename?: 'RentalApplication';
    id?: string | null;
    isArchived?: boolean | null;
    status?: ApplicantStatus | null;
    applicationStatus?: ApplicationStatus | null;
    isPrimaryApplicant?: boolean | null;
    startedByText?: string | null;
    startedDateTime?: string | null;
    invitedDateTime?: string | null;
    submittedDateTime?: string | null;
    invitedToMoveInDateTime?: string | null;
    withdrawnDateTime?: string | null;
    rentalListing?: {
      __typename?: 'RentalListing';
      listingAlias?: string | null;
      propertyUrl?: unknown | null;
      address?: {
        __typename?: 'RentalApplicationAddress';
        street?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: unknown | null;
        unit?: string | null;
      } | null;
      primaryPhoto?: { __typename?: 'RentalListingPhoto'; thumbUrl?: unknown | null } | null;
    } | null;
    applicationShareInformation?: {
      __typename?: 'ApplicationShareInformation';
      shareDateTime?: string | null;
      status?: ApplicationShareStatus | null;
      propertyId?: string | null;
      landlordEmail?: unknown | null;
      propertyAddress?: {
        __typename?: 'RentalApplicationAddress';
        street?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: unknown | null;
        unit?: string | null;
      } | null;
    } | null;
  } | null> | null;
  appfolioRentalApplications?: Array<{
    __typename?: 'AppfolioRentalApplication';
    id?: string | null;
    applicationUrl?: string | null;
    listingAlias?: string | null;
    status?: ApplicationStatus | null;
    startedDateTime?: string | null;
    approvedDateTime?: string | null;
    declinedDateTime?: string | null;
    submittedDateTime?: string | null;
    withdrawnDateTime?: string | null;
    displayablePhotoUrl?: string | null;
    address?: {
      __typename?: 'RentalApplicationAddress';
      street?: string | null;
      city?: string | null;
      state?: string | null;
      zip?: unknown | null;
    } | null;
  } | null> | null;
  userStatuses?: Array<{
    __typename?: 'UserStatus';
    type?: UserStatusType | null;
    status?: string | null;
    expirationDateTime?: string | null;
    requestedDateTime?: string | null;
  } | null> | null;
};

export type GetRentalApplicationsBrownoutWarningQueryVariables = Exact<{ [key: string]: never }>;

export type GetRentalApplicationsBrownoutWarningQuery = {
  __typename?: 'Query';
  rentalApplicationsBrownoutWarning?: string | null;
};

export type GetRentalApplicationIncomeDocsQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;

export type GetRentalApplicationIncomeDocsQuery = {
  __typename?: 'Query';
  rentalApplication?: {
    __typename?: 'RentalApplication';
    id?: string | null;
    answers?: {
      __typename?: 'Answers';
      id?: string | null;
      currentIncomes?: Array<
        | {
            __typename?: 'EmploymentIncome';
            id?: string | null;
            documents?: Array<{
              __typename?: 'Document';
              id?: string | null;
              previewUrl?: unknown | null;
              fileName?: string | null;
              isRedacted?: boolean | null;
              canBeRedacted?: boolean | null;
              isRedactionCheckComplete?: boolean | null;
              expirationDateTime?: string | null;
            } | null> | null;
          }
        | {
            __typename?: 'OtherIncome';
            id?: string | null;
            documents?: Array<{
              __typename?: 'Document';
              id?: string | null;
              previewUrl?: unknown | null;
              fileName?: string | null;
              isRedacted?: boolean | null;
              canBeRedacted?: boolean | null;
              isRedactionCheckComplete?: boolean | null;
              expirationDateTime?: string | null;
            } | null> | null;
          }
        | null
      > | null;
    } | null;
  } | null;
};

export type GetRentalApplicationQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;

export type GetRentalApplicationQuery = {
  __typename?: 'Query';
  rentalApplication?: {
    __typename?: 'RentalApplication';
    id?: string | null;
    status?: ApplicantStatus | null;
    applicationStatus?: ApplicationStatus | null;
    isPrimaryApplicant?: boolean | null;
    ireneViewedDateTime?: string | null;
    startedByText?: string | null;
    startedDateTime?: string | null;
    invitedDateTime?: string | null;
    submittedDateTime?: string | null;
    listingOwner?: {
      __typename?: 'ListingOwner';
      userId?: string | null;
      name?: string | null;
      email?: unknown | null;
      phone?: string | null;
    } | null;
    rentalListing?: {
      __typename?: 'RentalListing';
      listingAlias?: string | null;
      propertyUrl?: unknown | null;
      isActive?: boolean | null;
      isApplicationsAccepted?: boolean | null;
      bedrooms?: number | null;
      bathrooms?: unknown | null;
      squareFeet?: number | null;
      monthlyPayment?: string | null;
      address?: {
        __typename?: 'RentalApplicationAddress';
        street?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: unknown | null;
      } | null;
      primaryPhoto?: { __typename?: 'RentalListingPhoto'; imageUrl?: unknown | null } | null;
      receivedInvitations?: Array<{
        __typename?: 'ReceivedCoapplicantInvitation';
        id?: string | null;
        rentalApplicationInviteId?: string | null;
        invitedBy?: {
          __typename?: 'InvitedByContactInfo';
          email?: unknown | null;
          firstName?: string | null;
          lastName?: string | null;
          applicationId?: string | null;
        } | null;
      } | null> | null;
    } | null;
    answers?: {
      __typename?: 'Answers';
      id?: string | null;
      firstName?: string | null;
      middleName?: string | null;
      lastName?: string | null;
      phone?: string | null;
      email?: unknown | null;
      moveInDate?: string | null;
      isMoveInDateFlexible?: boolean | null;
      occupants?: number | null;
      isSmoker?: boolean | null;
      backgroundReportComment?: string | null;
      creditReportComment?: string | null;
      reasonForMoving?: string | null;
      pets?: {
        __typename?: 'Pets';
        smallDogs?: number | null;
        mediumDogs?: number | null;
        largeDogs?: number | null;
        cats?: number | null;
        other?: number | null;
        description?: string | null;
      } | null;
      currentIncomes?: Array<
        | {
            __typename?: 'EmploymentIncome';
            startDate?: string | null;
            id?: string | null;
            type?: IncomeType | null;
            title?: string | null;
            amount?: string | null;
            note?: string | null;
            areDocumentsExpired?: boolean | null;
            employer?: {
              __typename?: 'Employer';
              organization?: string | null;
              name?: string | null;
              email?: unknown | null;
              phone?: string | null;
            } | null;
            documents?: Array<{
              __typename?: 'Document';
              id?: string | null;
              expirationDateTime?: string | null;
              fileName?: string | null;
              previewUrl?: unknown | null;
              isRedacted?: boolean | null;
              canBeRedacted?: boolean | null;
              isRedactionCheckComplete?: boolean | null;
            } | null> | null;
          }
        | {
            __typename?: 'OtherIncome';
            id?: string | null;
            type?: IncomeType | null;
            title?: string | null;
            amount?: string | null;
            note?: string | null;
            areDocumentsExpired?: boolean | null;
            documents?: Array<{
              __typename?: 'Document';
              id?: string | null;
              expirationDateTime?: string | null;
              fileName?: string | null;
              previewUrl?: unknown | null;
              isRedacted?: boolean | null;
              canBeRedacted?: boolean | null;
              isRedactionCheckComplete?: boolean | null;
            } | null> | null;
          }
        | null
      > | null;
      pastJobs?: Array<{
        __typename?: 'PastJob';
        id?: string | null;
        title?: string | null;
        startDate?: string | null;
        endDate?: string | null;
        employer?: {
          __typename?: 'Employer';
          organization?: string | null;
          name?: string | null;
          email?: unknown | null;
          phone?: string | null;
        } | null;
      } | null> | null;
      currentResidence?:
        | {
            __typename?: 'OtherCurrentResidence';
            description?: string | null;
            zpid?: number | null;
            type?: ResidenceType | null;
            startDate?: string | null;
            monthlyPayment?: string | null;
            address?: {
              __typename?: 'RentalApplicationAddress';
              street?: string | null;
              city?: string | null;
              state?: string | null;
              zip?: unknown | null;
            } | null;
          }
        | {
            __typename?: 'OwnedCurrentResidence';
            zpid?: number | null;
            type?: ResidenceType | null;
            startDate?: string | null;
            monthlyPayment?: string | null;
            address?: {
              __typename?: 'RentalApplicationAddress';
              street?: string | null;
              city?: string | null;
              state?: string | null;
              zip?: unknown | null;
            } | null;
          }
        | {
            __typename?: 'RentalCurrentResidence';
            zpid?: number | null;
            type?: ResidenceType | null;
            startDate?: string | null;
            monthlyPayment?: string | null;
            manager?: {
              __typename?: 'ManagerContactInfo';
              name?: string | null;
              email?: unknown | null;
              phone?: string | null;
            } | null;
            address?: {
              __typename?: 'RentalApplicationAddress';
              street?: string | null;
              city?: string | null;
              state?: string | null;
              zip?: unknown | null;
            } | null;
          }
        | null;
      pastResidences?: Array<
        | {
            __typename?: 'OtherPastResidence';
            description?: string | null;
            type?: ResidenceType | null;
            startDate?: string | null;
            endDate?: string | null;
            address?: {
              __typename?: 'RentalApplicationAddress';
              street?: string | null;
              city?: string | null;
              state?: string | null;
              zip?: unknown | null;
            } | null;
          }
        | {
            __typename?: 'OwnedPastResidence';
            type?: ResidenceType | null;
            startDate?: string | null;
            endDate?: string | null;
            address?: {
              __typename?: 'RentalApplicationAddress';
              street?: string | null;
              city?: string | null;
              state?: string | null;
              zip?: unknown | null;
            } | null;
          }
        | {
            __typename?: 'RentalPastResidence';
            type?: ResidenceType | null;
            startDate?: string | null;
            endDate?: string | null;
            manager?: {
              __typename?: 'ManagerContactInfo';
              name?: string | null;
              email?: unknown | null;
              phone?: string | null;
            } | null;
            address?: {
              __typename?: 'RentalApplicationAddress';
              street?: string | null;
              city?: string | null;
              state?: string | null;
              zip?: unknown | null;
            } | null;
          }
        | null
      > | null;
      coapplicants?: Array<{
        __typename?: 'SentCoapplicantInvitation';
        id?: string | null;
        email?: unknown | null;
        firstName?: string | null;
        lastName?: string | null;
        invitedDateTime?: string | null;
      } | null> | null;
      customAnswers?: Array<{ __typename?: 'BooleanAnswer'; value?: boolean | null; id?: string | null } | null> | null;
    } | null;
    statusHistory?: Array<{
      __typename?: 'ApplicationStatusHistory';
      status?: string | null;
      date?: string | null;
    } | null> | null;
    applicationShareInformation?: {
      __typename?: 'ApplicationShareInformation';
      shareDateTime?: string | null;
      status?: ApplicationShareStatus | null;
      propertyId?: string | null;
      landlordEmail?: unknown | null;
      propertyAddress?: {
        __typename?: 'RentalApplicationAddress';
        street?: string | null;
        unit?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: unknown | null;
      } | null;
    } | null;
  } | null;
  userStatuses?: Array<{
    __typename?: 'UserStatus';
    type?: UserStatusType | null;
    status?: string | null;
    expirationDateTime?: string | null;
    requestedDateTime?: string | null;
  } | null> | null;
};

export type GetRentalApplicationsDocumentUploadTokenQueryVariables = Exact<{ [key: string]: never }>;

export type GetRentalApplicationsDocumentUploadTokenQuery = {
  __typename?: 'Query';
  rentalApplicationsDocumentUploadToken?: string | null;
};

export type GetTermSetQueryVariables = Exact<{
  termSetId: TermSetId;
}>;

export type GetTermSetQuery = {
  __typename?: 'Query';
  termSet?: {
    __typename?: 'TermSet';
    id?: TermSetId | null;
    status?: TermSetStatus | null;
    terms?: Array<{
      __typename?: 'Term';
      id?: TermId | null;
      currentVersion?: number | null;
      acceptedVersion?: number | null;
      acceptanceDateTime?: string | null;
    } | null> | null;
  } | null;
};

export type GetUserStatusesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserStatusesQuery = {
  __typename?: 'Query';
  userStatuses?: Array<{
    __typename?: 'UserStatus';
    type?: UserStatusType | null;
    status?: string | null;
    expirationDateTime?: string | null;
    requestedDateTime?: string | null;
  } | null> | null;
};

export type SetDocumentRedactionMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  isRedacted: Scalars['Boolean']['input'];
}>;

export type SetDocumentRedactionMutation = { __typename?: 'Mutation'; setDocumentRedactionStatus?: boolean | null };

export type SaveAnswersMutationVariables = Exact<{
  answers: AnswersInput;
  applicationId: Scalars['ID']['input'];
}>;

export type SaveAnswersMutation = {
  __typename?: 'Mutation';
  saveAnswers?: {
    __typename?: 'Answers';
    id?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
    phone?: string | null;
    email?: unknown | null;
    moveInDate?: string | null;
    isMoveInDateFlexible?: boolean | null;
    occupants?: number | null;
    isSmoker?: boolean | null;
    backgroundReportComment?: string | null;
    creditReportComment?: string | null;
    reasonForMoving?: string | null;
    pets?: {
      __typename?: 'Pets';
      smallDogs?: number | null;
      mediumDogs?: number | null;
      largeDogs?: number | null;
      cats?: number | null;
      other?: number | null;
      description?: string | null;
    } | null;
    currentIncomes?: Array<
      | {
          __typename?: 'EmploymentIncome';
          startDate?: string | null;
          id?: string | null;
          type?: IncomeType | null;
          title?: string | null;
          amount?: string | null;
          note?: string | null;
          areDocumentsExpired?: boolean | null;
          employer?: {
            __typename?: 'Employer';
            organization?: string | null;
            name?: string | null;
            email?: unknown | null;
            phone?: string | null;
          } | null;
          documents?: Array<{
            __typename?: 'Document';
            id?: string | null;
            expirationDateTime?: string | null;
            fileName?: string | null;
            previewUrl?: unknown | null;
            isRedacted?: boolean | null;
            canBeRedacted?: boolean | null;
            isRedactionCheckComplete?: boolean | null;
          } | null> | null;
        }
      | {
          __typename?: 'OtherIncome';
          id?: string | null;
          type?: IncomeType | null;
          title?: string | null;
          amount?: string | null;
          note?: string | null;
          areDocumentsExpired?: boolean | null;
          documents?: Array<{
            __typename?: 'Document';
            id?: string | null;
            expirationDateTime?: string | null;
            fileName?: string | null;
            previewUrl?: unknown | null;
            isRedacted?: boolean | null;
            canBeRedacted?: boolean | null;
            isRedactionCheckComplete?: boolean | null;
          } | null> | null;
        }
      | null
    > | null;
    pastJobs?: Array<{
      __typename?: 'PastJob';
      id?: string | null;
      title?: string | null;
      startDate?: string | null;
      endDate?: string | null;
      employer?: {
        __typename?: 'Employer';
        organization?: string | null;
        name?: string | null;
        email?: unknown | null;
        phone?: string | null;
      } | null;
    } | null> | null;
    currentResidence?:
      | {
          __typename?: 'OtherCurrentResidence';
          description?: string | null;
          zpid?: number | null;
          type?: ResidenceType | null;
          startDate?: string | null;
          monthlyPayment?: string | null;
          address?: {
            __typename?: 'RentalApplicationAddress';
            street?: string | null;
            city?: string | null;
            state?: string | null;
            zip?: unknown | null;
          } | null;
        }
      | {
          __typename?: 'OwnedCurrentResidence';
          zpid?: number | null;
          type?: ResidenceType | null;
          startDate?: string | null;
          monthlyPayment?: string | null;
          address?: {
            __typename?: 'RentalApplicationAddress';
            street?: string | null;
            city?: string | null;
            state?: string | null;
            zip?: unknown | null;
          } | null;
        }
      | {
          __typename?: 'RentalCurrentResidence';
          zpid?: number | null;
          type?: ResidenceType | null;
          startDate?: string | null;
          monthlyPayment?: string | null;
          manager?: {
            __typename?: 'ManagerContactInfo';
            name?: string | null;
            email?: unknown | null;
            phone?: string | null;
          } | null;
          address?: {
            __typename?: 'RentalApplicationAddress';
            street?: string | null;
            city?: string | null;
            state?: string | null;
            zip?: unknown | null;
          } | null;
        }
      | null;
    pastResidences?: Array<
      | {
          __typename?: 'OtherPastResidence';
          description?: string | null;
          type?: ResidenceType | null;
          startDate?: string | null;
          endDate?: string | null;
          address?: {
            __typename?: 'RentalApplicationAddress';
            street?: string | null;
            city?: string | null;
            state?: string | null;
            zip?: unknown | null;
          } | null;
        }
      | {
          __typename?: 'OwnedPastResidence';
          type?: ResidenceType | null;
          startDate?: string | null;
          endDate?: string | null;
          address?: {
            __typename?: 'RentalApplicationAddress';
            street?: string | null;
            city?: string | null;
            state?: string | null;
            zip?: unknown | null;
          } | null;
        }
      | {
          __typename?: 'RentalPastResidence';
          type?: ResidenceType | null;
          startDate?: string | null;
          endDate?: string | null;
          manager?: {
            __typename?: 'ManagerContactInfo';
            name?: string | null;
            email?: unknown | null;
            phone?: string | null;
          } | null;
          address?: {
            __typename?: 'RentalApplicationAddress';
            street?: string | null;
            city?: string | null;
            state?: string | null;
            zip?: unknown | null;
          } | null;
        }
      | null
    > | null;
    coapplicants?: Array<{
      __typename?: 'SentCoapplicantInvitation';
      id?: string | null;
      email?: unknown | null;
      firstName?: string | null;
      lastName?: string | null;
      invitedDateTime?: string | null;
    } | null> | null;
    customAnswers?: Array<{ __typename?: 'BooleanAnswer'; value?: boolean | null; id?: string | null } | null> | null;
  } | null;
};

export type ShareApplicationMutationVariables = Exact<{
  landlordEmail: Scalars['EmailAddress']['input'];
  propertyAddress: ShareRentalApplicationPropertyAddressInput;
  message?: InputMaybe<Scalars['String']['input']>;
}>;

export type ShareApplicationMutation = {
  __typename?: 'Mutation';
  shareApplication?: { __typename?: 'RentalApplication'; id?: string | null } | null;
};

export type InviteApplicantMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  applicant: InviteCoapplicantInput;
}>;

export type InviteApplicantMutation = {
  __typename?: 'Mutation';
  inviteCoapplicant?: {
    __typename?: 'SentCoapplicantInvitation';
    firstName?: string | null;
    lastName?: string | null;
    email?: unknown | null;
  } | null;
};

export type RemoveApplicantMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  invitationId: Scalars['ID']['input'];
}>;

export type RemoveApplicantMutation = { __typename?: 'Mutation'; removeInvitation?: boolean | null };

export type markAcceptedTermsMutationVariables = Exact<{
  terms: Array<InputMaybe<TermInput>> | InputMaybe<TermInput>;
}>;

export type markAcceptedTermsMutation = {
  __typename?: 'Mutation';
  markAcceptedTerms?: Array<{
    __typename?: 'Term';
    id?: TermId | null;
    version?: number | null;
    acceptanceDateTime?: string | null;
  } | null> | null;
};

export type AddDocumentsToIncomeSourceMutationVariables = Exact<{
  incomeSourceId: Scalars['ID']['input'];
  documents: Array<DocumentInput> | DocumentInput;
}>;

export type AddDocumentsToIncomeSourceMutation = {
  __typename?: 'Mutation';
  addDocumentToIncomeSource: Array<{
    __typename?: 'Document';
    id?: string | null;
    expirationDateTime?: string | null;
    fileName?: string | null;
    previewUrl?: unknown | null;
    isRedacted?: boolean | null;
    canBeRedacted?: boolean | null;
    isRedactionCheckComplete?: boolean | null;
  }>;
};

export type DeleteDocumentsFromIncomeSourceMutationVariables = Exact<{
  incomeSourceId: Scalars['ID']['input'];
  documentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DeleteDocumentsFromIncomeSourceMutation = {
  __typename?: 'Mutation';
  deleteDocumentsFromIncomeSource?: boolean | null;
};

export const GetApplicationsForUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetApplicationsForUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeSharedApplications' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rentalApplications' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeSharedApplications' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeSharedApplications' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isArchived' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimaryApplicant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedByText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invitedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'submittedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invitedToMoveInDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'withdrawnDateTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rentalListing' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'listingAlias' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'propertyUrl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryPhoto' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'thumbUrl' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationShareInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shareDateTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'landlordEmail' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appfolioRentalApplications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicationUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listingAlias' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'declinedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'submittedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'withdrawnDateTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'displayablePhotoUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userStatuses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestedDateTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetApplicationsForUserQuery, GetApplicationsForUserQueryVariables>;
export const GetRentalApplicationsBrownoutWarningDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRentalApplicationsBrownoutWarning' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'rentalApplicationsBrownoutWarning' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRentalApplicationsBrownoutWarningQuery,
  GetRentalApplicationsBrownoutWarningQueryVariables
>;
export const GetRentalApplicationIncomeDocsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRentalApplicationIncomeDocs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rentalApplication' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentIncomes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'documents' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRedacted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'canBeRedacted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRedactionCheckComplete' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expirationDateTime' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRentalApplicationIncomeDocsQuery, GetRentalApplicationIncomeDocsQueryVariables>;
export const GetRentalApplicationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRentalApplication' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rentalApplication' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicationStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPrimaryApplicant' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ireneViewedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedByText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'invitedDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'submittedDateTime' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'listingOwner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rentalListing' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'listingAlias' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'propertyUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isApplicationsAccepted' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'bedrooms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bathrooms' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'squareFeet' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'monthlyPayment' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryPhoto' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'receivedInvitations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rentalApplicationInviteId' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'invitedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'applicationId' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'answers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'middleName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'moveInDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMoveInDateFlexible' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'occupants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSmoker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'backgroundReportComment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creditReportComment' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'smallDogs' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mediumDogs' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'largeDogs' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cats' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'other' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentIncomes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'documents' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expirationDateTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRedacted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'canBeRedacted' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isRedactionCheckComplete' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'areDocumentsExpired' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EmploymentIncome' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'employer' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'organization' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pastJobs' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'organization' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reasonForMoving' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currentResidence' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'zpid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'monthlyPayment' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'RentalCurrentResidence' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'manager' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'OtherCurrentResidence' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pastResidences' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'RentalPastResidence' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'manager' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OtherPastResidence' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coapplicants' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'invitedDateTime' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customAnswers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BooleanAnswer' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statusHistory' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationShareInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'shareDateTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'landlordEmail' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userStatuses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestedDateTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRentalApplicationQuery, GetRentalApplicationQueryVariables>;
export const GetRentalApplicationsDocumentUploadTokenDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRentalApplicationsDocumentUploadToken' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'rentalApplicationsDocumentUploadToken' } }],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRentalApplicationsDocumentUploadTokenQuery,
  GetRentalApplicationsDocumentUploadTokenQueryVariables
>;
export const GetTermSetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTermSet' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'termSetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TermSetId' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termSet' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'termSetId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'terms' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'acceptedVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'acceptanceDateTime' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTermSetQuery, GetTermSetQueryVariables>;
export const GetUserStatusesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserStatuses' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userStatuses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestedDateTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserStatusesQuery, GetUserStatusesQueryVariables>;
export const SetDocumentRedactionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetDocumentRedaction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isRedacted' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setDocumentRedactionStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isRedacted' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isRedacted' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetDocumentRedactionMutation, SetDocumentRedactionMutationVariables>;
export const SaveAnswersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SaveAnswers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'answers' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AnswersInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'saveAnswers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'answers' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'answers' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'applicationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'middleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'moveInDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMoveInDateFlexible' } },
                { kind: 'Field', name: { kind: 'Name', value: 'occupants' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSmoker' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backgroundReportComment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditReportComment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'smallDogs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mediumDogs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'largeDogs' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cats' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'other' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentIncomes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'documents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expirationDateTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRedacted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canBeRedacted' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isRedactionCheckComplete' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'areDocumentsExpired' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EmploymentIncome' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employer' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'organization' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pastJobs' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employer' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'organization' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'reasonForMoving' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currentResidence' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'zpid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'monthlyPayment' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RentalCurrentResidence' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'manager' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OtherCurrentResidence' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pastResidences' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RentalPastResidence' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'manager' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OtherPastResidence' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'description' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coapplicants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invitedDateTime' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customAnswers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BooleanAnswer' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'value' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SaveAnswersMutation, SaveAnswersMutationVariables>;
export const ShareApplicationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ShareApplication' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'landlordEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmailAddress' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyAddress' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ShareRentalApplicationPropertyAddressInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shareApplication' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'landlordEmail' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'landlordEmail' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyAddress' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyAddress' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'message' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShareApplicationMutation, ShareApplicationMutationVariables>;
export const InviteApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InviteApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicant' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'InviteCoapplicantInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inviteCoapplicant' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'applicationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'applicant' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'applicant' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InviteApplicantMutation, InviteApplicantMutationVariables>;
export const RemoveApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'invitationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'applicationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'applicationId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'invitationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'invitationId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveApplicantMutation, RemoveApplicantMutationVariables>;
export const markAcceptedTermsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'markAcceptedTerms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'terms' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TermInput' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markAcceptedTerms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'terms' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'terms' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceDateTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<markAcceptedTermsMutation, markAcceptedTermsMutationVariables>;
export const AddDocumentsToIncomeSourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddDocumentsToIncomeSource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'incomeSourceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documents' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addDocumentToIncomeSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'incomeSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'incomeSourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documents' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documents' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationDateTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRedacted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canBeRedacted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isRedactionCheckComplete' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddDocumentsToIncomeSourceMutation, AddDocumentsToIncomeSourceMutationVariables>;
export const DeleteDocumentsFromIncomeSourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteDocumentsFromIncomeSource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'incomeSourceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteDocumentsFromIncomeSource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'incomeSourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'incomeSourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteDocumentsFromIncomeSourceMutation, DeleteDocumentsFromIncomeSourceMutationVariables>;
